import { useCallback, useState } from "react";

// eslint-disable-next-line
export const useConfirmationDialog = (confirmationCb: (id: string | number, optionalParams: any) => void) => {
    const [confirmationDialogState, setConfirmationDialogState] = useState<{
        isOpen: boolean;
        id?: string | number;
    }>({
        isOpen: false,
    });

    const handleOnExited = useCallback(() => setConfirmationDialogState((state) => ({ ...state, id: undefined })), []);

    const handleOnClose = useCallback(() => setConfirmationDialogState((state) => ({ ...state, isOpen: false })), []);

    const handleOnOpen = useCallback(
        (id: string | number) => () => setConfirmationDialogState({ isOpen: true, id }),
        []
    );

    const handleOnConfirm = useCallback(
        // eslint-disable-next-line
        (isConfirmed: boolean, optionalParams?: any) => {
            if (isConfirmed && confirmationDialogState.id) {
                return confirmationCb(confirmationDialogState.id, optionalParams);
            }

            handleOnClose();
        },
        [confirmationCb, handleOnClose, confirmationDialogState.id]
    );

    return {
        confirmationId: confirmationDialogState.id,
        isConfirmationOpen: confirmationDialogState.isOpen,
        handleOnExited,
        handleOnClose,
        handleOnOpen,
        handleOnConfirm,
    };
};
